import React from "react";
import Table from "../../../components/Table";
import TitleButtons from "../../../components/TitleButtons";
import { useSaidasSuprimentos } from "./saidas-servicoData";

const SuprimentosSaidas: React.FC = () => {
  const headers = [
    "OS",
    "Código",
    "Nome do Produto",
    "Quantidade",
    "Preço de Venda", // (antes: Custo Unitário)
    "R. Coleta",
    "Data",
    "Hora",
  ];

  const { rows, loading, refresh } = useSaidasSuprimentos();

  const columnWidths = [
    "60px", // OS
    "70px", // Código
    "300px", // Nome
    "50px", // Quantidade
    "90px", // Preço de Venda
    "90px", // Técnico
    "90px", // Data
    "60px", // Hora
  ];

  return (
    <div>
      <TitleButtons title="Coordenação - Baixas Serviços" buttons={[]} />
      <div
        style={{
          margin: "8px 0 6px",
          fontStyle: "italic",
          color: "#374151", // slate-700
        }}
      >
        Atenção: não utilize o <b>Preço de Venda</b> como guia para futuros
        lançamentos/medições, pois o preço exibido é referente ao preço do
        produto durante a data de registro da O.S. Alterações futuras no preço
        não são consideradas. Para checagem de preços atualizados, consulte a
        sessão
        <b> Produtos</b>.
      </div>

      <Table
        headers={headers}
        rows={rows}
        columnWidths={columnWidths}
        isTableStandby
      />
    </div>
  );
};

export default SuprimentosSaidas;
